import * as React from "react";
import { Dropdown, IDropdownOption, IDropdownStyles, ResponsiveMode } from "@fluentui/react";
import { IMultipleSelectionInput } from "../../../../../interfaces/advancedSearch/IMultipleSelectionInput";
import { toChoiceList } from "../../../../helpers/choiceOptionsHelper";

export const MultiChoicePicker: React.FunctionComponent<IMultipleSelectionInput> = props => {
  const [selectedKeys, setSelectedKeys] = React.useState<string[]>([]);
  // Choices normally arrive deduped from the field conversion and the cache read; deduping again is cheap insurance against a duplicate key.
  // Memoised so Fluent does not see a new options array on every render.
  const options = React.useMemo(() => toChoiceList(props.choices).map(item => ({ key: item, text: item })), [props.choices]);

  const handleOnChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    if (item) {
      let selected = item.selected
        ? [...selectedKeys, item.key as string]
        : selectedKeys.filter(key => key !== item.key);
      setSelectedKeys(selected);
      props.handleValueChange(props.searchInputData?.index, selected);
    }
  };

  const dropdownStyles: Partial<IDropdownStyles> = { root: { width: "100%" } };
  return (
    <Dropdown
      // responsiveMode={ResponsiveMode.small}
      placeholder="Select"
      label={props.displayName}
      selectedKeys={selectedKeys}
      onChange={handleOnChange}
      multiSelect
      options={options}
      className="xb-sp-input"
      styles={dropdownStyles}
    />
  );
};

export default MultiChoicePicker;
